module.exports = __webpack_public_path__ + "static/Chris-3a29e715dd26d41439d383b89f4a9f31.jpg";